import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "export-container" }
const _hoisted_2 = { class: "row mb-3" }
const _hoisted_3 = { class: "col-md-3" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardCard = _resolveComponent("DashboardCard")!
  const _component_DashboardDailyBilling = _resolveComponent("DashboardDailyBilling")!
  const _component_DashboardLeadTime = _resolveComponent("DashboardLeadTime")!
  const _component_DashboardReservedCollected = _resolveComponent("DashboardReservedCollected")!
  const _component_DashboardBilledReserved = _resolveComponent("DashboardBilledReserved")!
  const _component_DashboardMonthlyBilling = _resolveComponent("DashboardMonthlyBilling")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DashboardCard, {
          title: "Total de Pares / Peças Entregues em Estoque",
          loading: _ctx.loadingMonthTotals,
          "total-value": _ctx.monthTotals?.totalStockDelivery
        }, null, 8, ["loading", "total-value"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DashboardCard, {
          title: "Devolução em Pares / Peças",
          "total-value": _ctx.monthTotals?.totalDevolution,
          loading: _ctx.loadingMonthTotals
        }, null, 8, ["total-value", "loading"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DashboardCard, {
          title: "Faturado Líquido em Pares / Peças",
          "total-value": _ctx.monthTotals?.totalNetBilled,
          loading: _ctx.loadingMonthTotals
        }, null, 8, ["total-value", "loading"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_DashboardCard, {
          title: "Faturado Total em Pares / Peças",
          "total-value": _ctx.monthTotals?.totalBilled,
          loading: _ctx.loadingMonthTotals
        }, null, 8, ["total-value", "loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_DashboardDailyBilling, {
          "chart-value": _ctx.dailyBillingTotals?.monthBillingAverage / 1000,
          "average-period": parseInt(_ctx.dailyBillingTotals?.monthBillingAverage),
          "billed-day": _ctx.dailyBillingTotals?.dayBilling,
          loading: _ctx.loadingDailyBilling
        }, null, 8, ["chart-value", "average-period", "billed-day", "loading"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_DashboardLeadTime, {
          "lead-time-target": parseInt(_ctx.leadTimeTotals?.leadTimeTarget),
          "month-lead-time": _ctx.leadTimeTotals?.monthLeadTime,
          "orders-off-target": _ctx.leadTimeTotals?.ordersOffTarget,
          "orders-within-target": _ctx.leadTimeTotals?.ordersWithinTarget,
          loading: _ctx.loadingLeadTime
        }, null, 8, ["lead-time-target", "month-lead-time", "orders-off-target", "orders-within-target", "loading"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_DashboardReservedCollected, {
          onVnodeMounted: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checkSegments('Calçados'))),
          reserved: _ctx.reservedCollectedTotalsShoes?.reserved,
          picked: _ctx.reservedCollectedTotalsShoes?.picked,
          billed: _ctx.reservedCollectedTotalsShoes?.billed,
          loading: _ctx.loadingReservedCollected,
          segmentName: "Calçados"
        }, null, 8, ["reserved", "picked", "billed", "loading"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_DashboardReservedCollected, {
          onVnodeMounted: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkSegments('Outros'))),
          reserved: _ctx.reservedCollectedTotals?.reserved,
          picked: _ctx.reservedCollectedTotals?.picked,
          billed: _ctx.reservedCollectedTotals?.billed,
          loading: _ctx.loadingReservedCollected,
          segmentName: "Outros"
        }, null, 8, ["reserved", "picked", "billed", "loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_DashboardBilledReserved, {
          weekDays: _ctx.weekdays,
          shoesb: _ctx.billedReservedTotals?.shoes.billed,
          shoesr: _ctx.billedReservedTotals?.shoes.reserved,
          confectionb: _ctx.billedReservedTotals?.confection.billed,
          confectionr: _ctx.billedReservedTotals?.confection.reserved,
          accessoryb: _ctx.billedReservedTotals?.accessory.billed,
          accessoryr: _ctx.billedReservedTotals?.accessory.reserved,
          loading: _ctx.loadingBilledReserved
        }, null, 8, ["weekDays", "shoesb", "shoesr", "confectionb", "confectionr", "accessoryb", "accessoryr", "loading"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_DashboardMonthlyBilling, {
          "monthly-totals": _ctx.monthlyBillingTotals,
          loading: _ctx.loadingMonthlyBilling
        }, null, 8, ["monthly-totals", "loading"])
      ])
    ])
  ]))
}